import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import icons from "../../../icons.config"; // Ensure this includes a receipt icon

const OrderSuccessPopup = ({ orderId }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Disable scrolling when popup opens
    document.body.style.overflow = "hidden";

    // Auto-redirect to /shop after 10 seconds if no interaction
    const timer = setTimeout(() => {
      document.body.style.overflow = "auto";
      navigate("/shop");
    }, 10000);

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = "auto";
    };
  }, [navigate]);

  const handleYourOrdersClick = () => {
    document.body.style.overflow = "auto";
    navigate("/profile");
  };

  const handleShopMoreClick = () => {
    document.body.style.overflow = "auto";
    navigate("/shop");
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-scroll backdrop-blur-sm rounded">
      <div className="bg-tertiary p-11 md:p-6 rounded md:w-[50%] relative top-24 lg:top-7 text-center">
        {/* Heading */}
        <h1 className="font-outfit text-2xl lg:text-3xl mb-4 text-white">
          YOUR ORDER HAS BEEN PLACED!
        </h1>

        {/* Receipt Icon */}
        <div className="flex justify-center">
          <img
            src={icons.orderSuccess} // Using your updated icon
            alt="Receipt Icon"
            className="w-32 md:w-40 h-32 md:h-40"
          />
        </div>

        {/* Message with Order ID */}
        <p className="mt-4 text-md lg:text-lg text-white">
          Thank you for purchasing. Your order has been placed, here is the
          Order ID: <span className="font-semibold">{orderId || "N/A"}</span>
        </p>

        {/* Buttons */}
        <div className="mt-6 flex justify-center space-x-4">
          <button
            onClick={handleYourOrdersClick}
            className="px-6 py-2 bg-hcolor text-tertiary hover:bg-white hover:text-hcolor border border-hcolor rounded"
          >
            Your Orders
          </button>
          <button
            onClick={handleShopMoreClick}
            className="px-6 py-2 bg-hcolor text-tertiary hover:bg-white hover:text-hcolor border border-hcolor rounded"
          >
            Shop More
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPopup;